import strings from 'localization/strings';

const subscriptionEndReasons = {
    requestedByTenant: {},
    requestedByOwner: {},
    missingPaymentEndUnconfirmed: {},
    missingPaymentEndConfirmed: {},
    storageChanged: {},
    refund: {}
};

Object.keys(subscriptionEndReasons).forEach(key => {
    subscriptionEndReasons[key].key = key;
});

strings.addLoadCallback(() => {
    Object.keys(subscriptionEndReasons).forEach(key => {
        subscriptionEndReasons[key].title = strings.subscriptionEndReasons[key];
    });
});

export default subscriptionEndReasons;
